import { render } from "./NumberPage.vue?vue&type=template&id=4513082e&ts=true"
import script from "./NumberPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumberPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/number/NumberPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4513082e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4513082e', __exports__)) {
    api.reload('4513082e', __exports__)
  }
  
  module.hot.accept("./NumberPage.vue?vue&type=template&id=4513082e&ts=true", () => {
    api.rerender('4513082e', render)
  })

}


export default __exports__